import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.config.productionTip = false


const vues = document.querySelectorAll(".sku_calendar_month");
const each = Array.prototype.forEach;


each.call(vues, function (el, index)
{
    var data = {
        sku_id:  el.getAttribute('sku_id'),
        month: el.getAttribute('month'),
        year:  el.getAttribute('year'),
        months: el.getAttribute('months')
    }

    new Vue({
        data:   data,
        render: h => h(App),
    }).$mount(el)
})
